// tslint:disable
import { PathLayer } from "@deck.gl/layers";
import { BaseLayerClusterGeoJSONDeck } from "../../common/layers/baseLayerClusterGeoJSONDeck";
import { LAYERS_ID, LAYERS_SQL } from "./constants";
import { FilterSQL, hexToRgba } from "../../common/utils";
import { MvtService } from "../../common/services/mvt.service";
import { Colors } from "../../common/const";
// tslint:enable

export class JamServiceLevelLayer extends BaseLayerClusterGeoJSONDeck {
  data = [];
  zoom = 11;
  icon: string;
  layers = {
    [LAYERS_ID.WAZE_BCN_SERVICE_LEVEL_LINE_LAYER]: new PathLayer({
      id: LAYERS_ID.WAZE_BCN_SERVICE_LEVEL_LINE_LAYER,
      data: this.data,
      widthMinPixels: 2,
      getPath: (d) => this.getPath(d),
      getColor: (d) => this.getLineLayerColor(d),
      getWidth: (d) => 4,
    }),
  };

  filterUtils = new FilterSQL();

  constructor(
    private city,
    private mvtService: MvtService,
    private filters: any
  ) {
    super(LAYERS_ID.WAZE_BCN_SERVICE_LEVEL_LAYER);
  }

  updateSource() {
    this.mapContext.addToLoading(this);
    return this.getDataLayer().then((layers) => {
      layers.forEach((l) => {
        this.update(l.id, { data: this.data });
      });
      this.mapContext.removeFromLoading();
      return this.readViewPortFeatures();
    });
  }

  updateState() {}

  getDataLayer() {
    const p = [];
    Object.keys(this.layers).forEach((layer_id) => {
      let sql = LAYERS_SQL[layer_id];
      if (this.filters) {
        if (this.filters.fromDate) {
          sql = this.filterUtils.filterQuery(
            LAYERS_SQL[layer_id],
            this.filters
          );
        }
      }
      p.push(this.mvtService.getAPIData(sql).toPromise());
    });
    return Promise.all(p).then((values: any) => {
      this.data = values[0].rows;
      // console.log()
      return Object.keys(this.layers).map((id, idx) => ({
        id,
        data: this.data,
      }));
    });
  }

  getPath(d) {
    return JSON.parse(d.geojson).coordinates[0];
  }

  getTo(d) {
    return JSON.parse(d.geojson).coordinates[1];
  }

  getLineLayerColor(properties) {
    let color = '#000';

    const colors = [
      Colors.level1,
      Colors.level2,
      Colors.level3,
      Colors.level4,
      Colors.level5,
    ];
    const idx = Math.min(Math.max(0, properties.level - 1), colors.length);
    color = colors[idx];
    return hexToRgba(color, 60);
  }
}



// WEBPACK FOOTER //
// ./src/app/historic/layers/jamServiceLevelLayer.ts